'use client';

import * as React from 'react';
import dynamic from 'next/dynamic';

import { useCssDimensions } from '@/utils/hooks/useCssDimensions';

import { SwiperElement } from '@/components/molecules/SwiperElement';
import type { SectionProps } from '@/components/layout/Section';
import Section from '@/components/layout/Section';

import NumberItem from './components/NumberItem';
import type { DataInNumbersSectionConfigType } from './DataInNumbersSection.types';

const H2 = dynamic(() => import('@/components/atoms/Typography/H2'));

export interface DataInNumbersSectionProps extends SectionProps {
    config: DataInNumbersSectionConfigType;
}

const DataInNumbersSection = React.forwardRef<
    HTMLDivElement,
    DataInNumbersSectionProps
>(({ config, className, ...props }, ref) => {
    const { minWidthMd } = useCssDimensions();

    return (
        <Section
            className={className}
            ref={ref}
            {...props}
        >
            {config.title ? (
                <H2 className="heading-spaces">{config.title}</H2>
            ) : null}

            {minWidthMd ? (
                <div className="hidden flex-wrap justify-center gap-8 md:flex lg:flex-nowrap xl:gap-14">
                    {config.numbersData.map(elem => (
                        <NumberItem
                            key={elem.id}
                            itemData={elem}
                        />
                    ))}
                </div>
            ) : (
                <SwiperElement
                    pagination={true}
                    slidesPerView={1}
                    className="w-full !pb-6 md:!hidden"
                >
                    {config.numbersData.map(elem => (
                        <NumberItem
                            key={elem.id}
                            itemData={elem}
                            className="pb-12"
                        />
                    ))}
                </SwiperElement>
            )}
        </Section>
    );
});

export default DataInNumbersSection;
